import { Col, Grid, Loading, Row } from 'Common';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { LOADING } from 'Redux/userInterface/userInterfaceConstants';
import { t } from 'Utils/localization/i18next';
import styles from './DashboardBody.module.scss';

class DashboardBody extends React.PureComponent {
  render() {
    if (this.props.isLoading) {
      return (
        <Loading
          showLoadingBall={true}
          text={t(`loaders.dashboard_${Math.ceil(Math.random() * 3)}`)}
        />
      );
    }

    return (
      <div className={styles['content-container']}>
        <Grid className={styles['dashboard-body-left-menu']}>
          <Row center className={styles['dashboard-body-content']}>
            <Col
              xs={1}
              sm={12}
              md={12}
              lg={3}
              className={styles['col-left-menu']}
            >
              <section className={styles['col-side-menu']}>
                <div id="wlo-navigation" key="wlo-navigation"></div>
              </section>
            </Col>
            <Col
              xs={12}
              sm={9}
              md={9}
              lg={9}
              className={styles['col-content-pane-left']}
            >
              {this.props.children}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

DashboardBody.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

const mapStateToProps = state => ({
  isLoading: state.userInterface.loading[LOADING.PROFILE_GET]
});

export default connect(mapStateToProps)(DashboardBody);
